import React from 'react';

import { Div } from 'nexcomponent-ui';

import {
  divisionBreadCrumb,
} from '../../../../Enum/Breadcrumb/DivisionBreadcrumb';
import { divisionColumn } from '../../../../Enum/Column/DivisionColumn';
import { PAGE } from '../../../../Enum/IdSet';
import { MAPPING_CODE } from '../../../../Enum/MappingCode/MappingCode';
import {
  ROUTER_CONSTANT,
} from '../../../../Enum/RouterConstant/RouterConstant';
import { postRejectDivisionList } from '../../../../Fetch/Api/DivisionAPI';
import {
  fetchDivisionMappingForm,
} from '../../../../Fetch/FetchData/DivisionData';
import CancelRejectButton
  from '../../../Organisms/Button/CancelRejectButton/CancelRejectButton';
import HeaderPage from '../../../Organisms/Header/HeaderPage/HeaderPage';
import ModalReject from '../../../Organisms/Modal/ModalReject/ModalReject';
import RejectReasonList
  from '../../../Organisms/TableList/RejectReasonList/RejectReasonList';

const DivisionRejectReasonPage = props => (
  <Div id={PAGE.REJECT_LIST}>
    <ModalReject
      t={props.t}
      onReject={true}
      dispatch={props.dispatch}
      navigate={props.navigate}
      mappingCode={MAPPING_CODE.DIVISION}
      rejectFunc={(data, notify, dispatch) =>
        postRejectDivisionList(props.validToken(), data, notify, dispatch)
      }
      uniqueKey={"division_id"}
      nextMapping={(newId, existId, mappingList, nav) =>
        fetchDivisionMappingForm(
          props.validToken(),
          props.dispatch,
          "division_id",
          newId,
          existId,
          mappingList,
          props.notify,
          () => props.navigate(nav)
        )
      }
    />
    <HeaderPage
      title={props.t("DIVISION:TITLE")}
      listBreadcrumb={divisionBreadCrumb(props.t)}
      defaultBreadcrumb={props.t("COMMON:REJECT_REASON")}
      toTitlePageto={ROUTER_CONSTANT.DIVISION.LIST}
    />
    <RejectReasonList
      t={props.t}
      dispatch={props.dispatch}
      column={divisionColumn(props.t)}
      mappingCode={MAPPING_CODE.DIVISION}
    />
    <CancelRejectButton
      backPage={ROUTER_CONSTANT.DIVISION.LIST}
      mappingCode={MAPPING_CODE.DIVISION}
      onReject={true}
      t={props.t}
      dispatch={props.dispatch}
      navigate={props.navigate}
    />
  </Div>
);

export default DivisionRejectReasonPage;
